<template>
  <div class="contact-us full-screen bg-light">
    <div class="wrapper wrapper-full-page section content">
      <div class="pt-4">
        <div class="container">
          <div class="row">
            <div class="col-md-8 offset-md-2 text-center">
              <h2 class="text-success"><span class="ti-check-box"></span> Θα λάβετε σε λίγο τον σύνδεσμο αλλαγής ηλεκτρονικής διεύθυνσης στο νέο email που δηλώσατε</h2>
              <p class="text-muted mt-4">Μπορείτε να κλείσετε αυτή τη σελίδα</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>
